import { TreeList, TreeListDraggableRow } from "@progress/kendo-react-treelist";
import { useActions } from "../../../../Hooks/Display/useComponentProperties";
import AddCell from "./Cells/AddCell";
import DeleteCell from "./Cells/DeleteCell";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { getActionById } from "../utils";
import NameCell from "./Cells/NameCell";
import { reorderTreeList } from "./utils";
import TargetCell from "./Cells/TargetCell";
import IdCell from "./Cells/IdCell";
import NormalCell from "./Cells/NormalCell";
import { usePropsStoreValue } from "../../../../Hooks/PropStore/usePropsStore";
import ShowCell from "./Cells/ShowCell";
import { useTranslation } from "react-i18next";

function ActionTableTreeList() {

    const accessedFromDesigner = usePropsStoreValue("accessedFromDesigner");
    const selectedComponent = useSelectedComponent();

    const [state, dispatch] = useActions();

    const { t } = useTranslation("actions/action_grid", {
        useSuspense: false
    })

    const accessedFromDesignerColumns = [
        {
            field: "",
            title: "",
            cell: (props) => <AddCell {...props} hidden={selectedComponent.hidden} onAddClick={toggleCreateActionDialog} />,
        },
        {
            field: "",
            title: "#",
            cell: (props) => <IdCell {...props} hidden={selectedComponent.hidden} />
        },
        {
            field: "actionName",
            title: t("grid.columns.name"),
            expandable: true,
            cell: (props) => (
                <NameCell
                    {...props}
                    hidden={selectedComponent.hidden}
                    accessedFromDesigner={accessedFromDesigner}
                    onExpandChange={toggleExpanded}
                    onEdit={toggleUpdateActionDialog}
                />
            )
        },
        {
            field: "actionDisplay",
            title: "Action Display",
            cell: (props) => <NormalCell {...props} hidden={selectedComponent.hidden} />
        },
        {
            field: "label",
            title: "Label",
            cell: (props) => <NormalCell {...props} hidden={selectedComponent.hidden} />
        },
        {
            field: "actionType",
            title: "Action Type",
            cell: (props) => <NormalCell {...props} hidden={selectedComponent.hidden} />
        },
        {
            field: "target",
            title: "Target",
            cell: (props) => <TargetCell {...props} hidden={selectedComponent.hidden} />
        },
        {
            field: "targetShowAs",
            title: "Target Show As",
            cell: (props) => <NormalCell {...props} hidden={selectedComponent.hidden} />
        },
        {
            field: "tooltip",
            title: "Tooltip",
            cell: (props) => <NormalCell {...props} hidden={selectedComponent.hidden} />
        },
        {
            field: "",
            title: "",
            cell: (props) => (
                <ShowCell
                    {...props}
                    hidden={selectedComponent.hidden}
                    onChange={handleShowChange}
                />
            )
        },
        {
            field: "",
            title: "",
            cell: (props) => <DeleteCell {...props} hidden={selectedComponent.hidden} deleteAction={handleDelete} />
        }
    ]

    const accessedFromRuntimeColumns = [
        {
            field: "",
            title: "#",
            width: "50px",
            cell: (props) => <IdCell {...props} />
        },
        {
            field: "actionName",
            title: t("grid.columns.name"),
            expandable: true,
            width: "200px",
            cell: (props) => (
                <NameCell
                    {...props}
                    hidden={selectedComponent.hidden}
                    accessedFromDesigner={accessedFromDesigner}
                    onExpandChange={toggleExpanded}
                    onEdit={toggleUpdateActionDialog}
                />
            )
        },
        {
            field: "",
            title: "",
            cell: (props) => (
                <ShowCell
                    {...props}
                    hidden={selectedComponent.hidden}
                    onChange={handleShowChange}
                />
            )
        },
        {
            field: "",
            title: "",
            cell: (props) => <DeleteCell {...props} deleteAction={handleDelete} />
        }
    ]

    // functions
    function toggleExpanded(actionId) {
        dispatch.toggleExpanded(actionId);
    }

    function toggleCreateActionDialog(actionId) {
        dispatch.toggleCreateActionDialog(actionId);
    }

    function toggleUpdateActionDialog(actionId) {
        dispatch.toggleUpdateActionDialog(actionId);
    }

    function handleShowChange(event, actionId) {
        const actionToUpdate = getActionById(state.actions, actionId);
        if (actionToUpdate.actions && actionToUpdate.actions.length > 0) {
            actionToUpdate.actions.forEach(action => action.show = event.target.checked);
        }
        dispatch.updateAction(
            actionId, { ...actionToUpdate, show: event.target.checked }
        );
    }

    async function handleDelete(actionId) {
        // const actionToDelete = getActionById(state.actions, actionId);
        // await deleteAction(selectedPage._id, selectedComponent.id, actionToDelete.parentId, actionId);
        dispatch.deleteAction(actionId);
    }

    async function handleReorder(e) {
        if (selectedComponent.hidden) {
            return;
        }
        const newList = reorderTreeList(e, state.actions);
        dispatch.setActions(newList)
    }

    return (
        <div className="pb-5">
            <TreeList
                data={state.actions}
                columns={accessedFromDesigner ? accessedFromDesignerColumns : accessedFromRuntimeColumns}
                expandField="expanded"
                subItemsField="actions"
                row={TreeListDraggableRow}

                onExpandChange={toggleExpanded}
                onRowDrop={handleReorder}
            />
        </div>
    );
}

export default ActionTableTreeList;